<template>
    <div style="background:rgba(0,0,0,0.5);position:relative;" 
         :style="{display:show?'block':'none'}">
        <div style="position:relative;width:100%;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

            <div class="pbcss-loading-bg-gif">
                
            </div>  

        </div>
    </div>
</template>
<script>
    export default {
        props: ['show']
    }
</script>